import React from "react";
import TableRow from "@mui/material/TableRow";
import { Provider } from "../../../../data/entities";
import { StyledTableCell } from "../../../../shared/components/CustomTable/Styled";
import { StyledNavLink } from "../../../../shared/styled/TableStyles";
import { ContactInfo, ContactName } from "./Styled";

interface ProviderRowProps {
    item: Provider;
}

const ProviderRow = ({ item }: ProviderRowProps) => {
    const ContactDetail = () => {
        // Ensure contact_list is an array
        if (!Array.isArray(item.contact_list) || item.contact_list.length === 0) return "Chưa có";

        const contactPerson = item.contact_list.find(
            (contact) => contact.contact.is_default
        );

        return (
            <>
                <ContactName>{contactPerson?.contact.name}</ContactName>
                {contactPerson?.contact.phone && (
                    <>
                        {" "}
                        -{" "}
                        <ContactInfo>
                            {contactPerson?.contact.phone}
                        </ContactInfo>
                    </>
                )}
                {contactPerson?.contact.email && (
                    <>
                        {" "}
                        -{" "}
                        <ContactInfo>
                            {contactPerson?.contact.email}
                        </ContactInfo>
                    </>
                )}
            </>
        );
    };

    return (
        <TableRow>
            <StyledTableCell>
                <StyledNavLink to={`/providers/${item.id}`}>
                    {item.provider_code ? item.provider_code : item.id}
                </StyledNavLink>
            </StyledTableCell>
            <StyledTableCell>{item.name}</StyledTableCell>
            <StyledTableCell>{item.phone}</StyledTableCell>
            <StyledTableCell>{item.email}</StyledTableCell>
            <StyledTableCell>{ContactDetail()}</StyledTableCell>
            {/* <StyledTableCell>{item.address}</StyledTableCell> */}
            {/*<StyledTableCell>{item.number_of_current_orders}</StyledTableCell>*/}
            {/*<StyledTableCell>{item.number_of_orders}</StyledTableCell>*/}
        </TableRow>
    );
};

export default ProviderRow;
